import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Client } from '../entities/client';
import { ClientStorage } from '../entities/clientStorage';
import { MenuController, AlertController } from '@ionic/angular';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Event as NavigationEvent } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  observer: any;
  previouspage: string = '';

  constructor(
    public storage: Storage,
    private menuprincipal: MenuController,
    private router: Router,
    public alertController: AlertController
  ) { }

  async Logout() {
    this.menuprincipal.enable(false, 'main-menu');
    this.storage.remove('token');
    this.storage.remove('client');
    this.storage.remove('public');
    //this.loading.dismiss();

    //Elimina datos de tarjeta
    this.storage.remove('CardTypeId');
    this.storage.remove('CardTypeDesc');
    this.storage.remove('CardName');
    this.storage.remove('CardNumber');
    this.storage.remove('CardExpiration');
    this.storage.remove('CardAmount');
    if (this.observer) {
      this.observer.unsubscribe();
      this.observer = null;
    }
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['home']);
    this.previouspage = '/home';

    this.observandoLogout();
  }

  async ForceLogout() {
    this.menuprincipal.close('main-menu');
    this.storage.remove('token');
    this.storage.remove('client');
    this.storage.remove('public');
    //this.loading.dismiss();

    //Elimina datos de tarjeta
    this.storage.remove('CardTypeId');
    this.storage.remove('CardTypeDesc');
    this.storage.remove('CardName');
    this.storage.remove('CardNumber');
    this.storage.remove('CardExpiration');
    this.storage.remove('CardAmount');
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Actualización',
      backdropDismiss: false,
      message: 'Por actualización de versión se requiere que inicie sesión nuevamente.',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate(['home']);
            
          },
        }
      ],
    });
    alert.present();
  }
  async cleanPaymentCard() {
    this.storage.remove('CardTypeId');
    this.storage.remove('CardTypeDesc');
    this.storage.remove('CardName');
    this.storage.remove('CardNumber');
    this.storage.remove('CardExpiration');
    this.storage.remove('CardAmount');
  }

  async cleanFlujo() {
    this.storage.remove('Flujo');
  }

  async confirmLogout(message: string) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Cerrar sesión',
      backdropDismiss: false,
      message: message,
      buttons: [
        {
          text: 'Salir',
          handler: () => {
            this.Logout();
          },
        },
        {
          text: 'Cancelar',
          handler: () => {
            this.storage.get('client').then((cliente) => {
              if (cliente) {
                if (cliente.LoginType == 4) {
                  this.router.navigate(['seereservation']);
                } else {
                  this.router.navigate(['menusearchreservation']);
                }
              }
            });
          },
        },
      ],
    });
    await alert.present();
  }

  observandoLogout() {
    if (!this.observer) {
      this.observer = this.router.events
        .pipe(
          filter((event: NavigationEvent) => {
            return event instanceof NavigationStart;
          })
        )
        .subscribe((event: NavigationStart) => {
          if (
            (event.url == '/login' ||
              event.url == '/' ||
              event.url == '/home') &&
            (this.previouspage.startsWith('/seereservation') ||
              this.previouspage.startsWith('/menusearchreservation') ||
              this.previouspage.startsWith('/ofertahoteles'))
          ) {
            this.confirmLogout('¿Desea salir de la aplicación?');
          }
          this.previouspage = event.url;
          if (event.restoredState) {
          }
        });
    }
  }
}
